import React from "react";
import { Modal } from "react-bootstrap";
import { DetailRow } from "./SupplierManagementPrimitives";
import InvitationStatusBadge from "./InvitationStatusBadge";
import {
  buildSupplierInvitationAcceptUrl,
  copySupplierInvitationLink,
  formatDateTime,
  isPendingInvitation,
} from "./supplierManagementHelpers";
import {
  detailLabelStyle,
  detailSectionStyle,
  detailSectionTitle,
} from "./supplierManagementStyles";

const InvitationDetailsModal = ({ show, invitation, onClose, onResend }) => {
  const inviteUrl = invitation
    ? buildSupplierInvitationAcceptUrl(invitation.invitationToken)
    : null;
  const showInviteLink =
    !!invitation &&
    Boolean(invitation.invitationToken) &&
    isPendingInvitation(invitation.statusKey) &&
    Boolean(inviteUrl);

  return (
    <Modal show={show} onHide={onClose} centered size="lg" scrollable>
      <Modal.Header closeButton style={{ borderBottom: "1px solid var(--rule)" }}>
        <Modal.Title style={{ fontSize: 17, fontWeight: 800, color: "var(--ink)" }}>
          Invitation details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ background: "#f0f2f5" }}>
        {!invitation ? (
          <div style={{ padding: 32, textAlign: "center", color: "var(--ink-4)" }}>
            No details available.
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <div
              style={{
                ...detailSectionStyle,
                background: "var(--surface)",
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 12,
              }}
            >
              <div style={{ minWidth: 0 }}>
                <div
                  style={{
                    fontSize: 18,
                    fontWeight: 800,
                    color: "var(--ink)",
                    lineHeight: 1.2,
                  }}
                >
                  {invitation.companyName || "—"}
                </div>
                <div
                  style={{
                    fontSize: 12,
                    color: "var(--ink-3)",
                    marginTop: 4,
                  }}
                >
                  {invitation.email || "—"}
                </div>
              </div>
              <InvitationStatusBadge statusKey={invitation.statusKey} />
            </div>

            <div style={detailSectionStyle}>
              <div style={detailSectionTitle}>Timeline</div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                  gap: 12,
                }}
              >
                <DetailRow label="Invited on" value={formatDateTime(invitation.createdAt)} />
                <DetailRow label="Expires on" value={formatDateTime(invitation.expiresAt)} />
                <DetailRow label="Accepted on" value={formatDateTime(invitation.acceptedAt)} />
              </div>
            </div>

            {showInviteLink ? (
              <div style={detailSectionStyle}>
                <div style={detailSectionTitle}>Invitation link</div>
                <div style={{ minWidth: 0 }}>
                  <div style={detailLabelStyle}>Accept invitation URL</div>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 8,
                      alignItems: "center",
                      marginTop: 4,
                    }}
                  >
                    <a
                      href={inviteUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        fontSize: 12,
                        color: "var(--accent, #2563eb)",
                        wordBreak: "break-all",
                        flex: "1 1 200px",
                        minWidth: 0,
                      }}
                    >
                      {inviteUrl}
                    </a>
                    <button
                      type="button"
                      className="kpi-btn-secondary"
                      style={{ flexShrink: 0 }}
                      onClick={() =>
                        copySupplierInvitationLink(invitation.invitationToken)
                      }
                    >
                      Copy link
                    </button>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer style={{ borderTop: "1px solid var(--rule)", gap: 8 }}>
        {invitation?.invitationToken && isPendingInvitation(invitation.statusKey) ? (
          <button
            type="button"
            className="kpi-btn-secondary"
            onClick={() => copySupplierInvitationLink(invitation.invitationToken)}
          >
            Copy invitation link
          </button>
        ) : null}
        {invitation?.supplierId ? (
          <button
            type="button"
            className="kpi-btn-secondary"
            onClick={() => {
              onClose();
              onResend(invitation.supplierId);
            }}
          >
            Resend invitation
          </button>
        ) : null}
        <button type="button" className="kpi-btn-secondary" onClick={onClose}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default InvitationDetailsModal;
